import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets.app/images/onboarding/check.svg'
import _imports_1 from '@/assets.app/images/onboarding/stars.svg'


const _withScopeId = n => (_pushScopeId("data-v-6262ca32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onboarding-finishing" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "onboarding-finishing__progress" }
const _hoisted_4 = { class: "onboarding-finishing__progress-label" }
const _hoisted_5 = { class: "onboarding-finishing__steps" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "onboarding-finishing__step-dot" }, null, -1))
const _hoisted_7 = { class: "onboarding-finishing__step-title" }
const _hoisted_8 = {
  key: 0,
  class: "onboarding-finishing__status onboarding-finishing__status--prev"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "onboarding-finishing__icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "onboarding-finishing__status onboarding-finishing__status--next"
}
const _hoisted_12 = {
  key: 0,
  class: "onboarding-finishing__reviews"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "onboarding-finishing__stars"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "onboarding-finishing__review" }, "Enjoyed by 1M+ users", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "onboarding-finishing__popup"
}
const _hoisted_17 = { class: "onboarding-finishing__popup-inner" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "onboarding-finishing__popup-label" }, " To continue, answer: ", -1))
const _hoisted_19 = { class: "onboarding-finishing__popup-title" }
const _hoisted_20 = { class: "onboarding-finishing__popup-controls" }

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import {
  FinishingSetupChoice,
  FinishingSetupPage,
  FinishingSetupPageSteps,
} from '@/models/onboarding.types'
import { PublicInterface } from '@/models/interfaces'

import FinishingSetupSpinner from '../FinishingSetupSpinner.vue'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FinishingSetup',
  props: {
    view: null
  },
  setup(__props: any) {

const props = __props as {
  view: PublicInterface<QuestionnaireView>
};



const page = computed(() => {
  return props.view.currentPage as FinishingSetupPage
})

const pageTitle = computed(() => {
  if (finishedLoading.value) {
    return page.value.title
  }

  return page.value.titleLoading
})

const currentStepIndex = ref(0)
const currentQuestion = computed(() => {
  return page.value.steps[currentStepIndex.value].question
})

const finishedLoading = ref(false)

const showQuestionPopup = ref(false)

const nextQuestionThreshold = computed(() => {
  return (currentStepIndex.value + 1) * (100 / page.value.steps.length)
})

const currentChoice = computed(() => {
  return props.view.currentChoice as FinishingSetupChoice
})

function submitAnswer(answer: boolean): void {
  if (answer === true) {
    props.view.setCurrentChoice([...currentChoice.value, currentQuestion.value])
  }

  if (currentStepIndex.value + 1 === page.value.steps.length) {
    finishedLoading.value = true
    showQuestionPopup.value = false
    props.view.showContinueButton()
    return
  }

  showQuestionPopup.value = false
  startInterval()
  currentStepIndex.value++
}

function getStepTitle(
  step: FinishingSetupPageSteps,
  stepIndex: number,
): string {
  if (stepIndex >= currentStepIndex.value && !finishedLoading.value) {
    return step.titleLoading
  }

  return step.title
}

const updateProgressInterval = ref<number | null>(null)
const loadingProgress = ref(0)

function startInterval(): void {
  if (updateProgressInterval.value) {
    return
  }

  updateProgressInterval.value = setInterval(() => {
    loadingProgress.value += 2
  }, 150)

  showQuestionPopup.value = false
}

function stopInterval(): void {
  if (updateProgressInterval.value) {
    clearInterval(updateProgressInterval.value)
    updateProgressInterval.value = null
  }
}

watch(loadingProgress, (newValue) => {
  if (newValue >= nextQuestionThreshold.value) {
    stopInterval()
    showQuestionPopup.value = true
  }
})

onMounted(() => {
  // The default value of `view.currentChoice` is `undefined`.
  // The value of the choices for this page is an array, so
  // we set the initial value of `view.currentChoice` to an
  // empty array so that we can spread the current value
  // without having to check if it's an array first.
  props.view.setCurrentChoice([])
  startInterval()
})

onUnmounted(() => {
  stopInterval()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      class: "onboarding-finishing__title",
      innerHTML: _unref(pageTitle)
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "onboarding-finishing__progress-bar",
        style: _normalizeStyle({
          '--current-progress': `${loadingProgress.value}%`,
        })
      }, null, 4),
      _createElementVNode("p", _hoisted_4, _toDisplayString(loadingProgress.value) + "%", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(page).steps, (step, index) => {
        return (_openBlock(), _createBlock(_Transition, {
          key: step.title,
          name: "swap-state",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: getStepTitle(step, index),
              class: _normalizeClass(["onboarding-finishing__step", {
            'onboarding-finishing__step--prev':
              index < currentStepIndex.value || finishedLoading.value,
            'onboarding-finishing__step--current':
              index === currentStepIndex.value && !finishedLoading.value,
            'onboarding-finishing__step--next': index > currentStepIndex.value,
          }])
            }, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(getStepTitle(step, index)), 1),
              (index < currentStepIndex.value || finishedLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                : (index === currentStepIndex.value)
                  ? (_openBlock(), _createBlock(FinishingSetupSpinner, {
                      key: 1,
                      class: "onboarding-finishing__status onboarding-finishing__status--current"
                    }))
                  : _createCommentVNode("", true),
              (index > currentStepIndex.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : _createCommentVNode("", true)
            ], 2))
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    (!__props.view.isContinueButtonVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#appRoot" }, [
      _createVNode(_Transition, { name: "popup-pop" }, {
        default: _withCtx(() => [
          (showQuestionPopup.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(currentQuestion)), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(AppButton, {
                      class: "onboarding-finishing__popup-button onboarding-finishing__popup-button--no",
                      outlined: true,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (submitAnswer(false)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("No")
                      ]),
                      _: 1
                    }),
                    _createVNode(AppButton, {
                      class: "onboarding-finishing__popup-button onboarding-finishing__popup-button--yes",
                      outlined: true,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (submitAnswer(true)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Yes")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})